import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";

const ViewModalNewsDiscription = ({ 
  onClose, 
  isVisible, 
  onConfirm, // Function to handle different delete actions
  title = "Are you sure?", // Default title
  description = "Are you certain you want to delete this record?", // Default description
  data
}) => {
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Enter") {
        onConfirm(); // Trigger the confirm action
      }
    };

    if (isVisible) {
      window.addEventListener("keydown", handleKeyDown);
    }

    // Cleanup the event listener on component unmount or when modal visibility changes
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isVisible, onConfirm]);

  function decodeHTMLEntities(text) {
    const textarea = document.createElement("textarea");
    textarea.innerHTML = text;
    return textarea.value;
  }

  return (
    <Modal
      show={isVisible}
      onHide={onClose}
      size={"md"}
      className="custom-modal viewNewsDiscription"
      centered
    >
      <Modal.Header>
        <Modal.Title className="text-center">News Description</Modal.Title>
      </Modal.Header>
      <Modal.Body className="max-h-[calc(theme('height.screen')_-_180px)] p-4 overflow-y-auto">
        <div className="">
            <div dangerouslySetInnerHTML={{__html: decodeHTMLEntities(data)}} className="mb-1"></div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ViewModalNewsDiscription;